import "./Inquiry.module.css";
import Header from "@/reusable_sections/Header";
import HealthcareKnowledgeHub from "./sections/HealthcareKnowledgeHub";
import RequestATechnicalProposal from "./sections/RequestATechnicalProposal";
import StartYourJourney from "./sections/StartYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function InquiryPage() {
  return <div>
      <Header />
      <HealthcareKnowledgeHub />
      <RequestATechnicalProposal />
      <StartYourJourney />
      <Footer />
    </div>;
}